(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs-group"] && !Shopify.designMode) return;
  try {
    
  /*
    Two small jobs only — the theme's own collection-tabs script still owns the
    tab switching and the carousels:
      1. open the tab marked as default (the theme opens the first one),
      2. point the "show more" button at the active tab's collection.
  */
  (function () {
    var ROOT = '[data-collection-tabs-group]';

    function links(root) {
      return root.querySelectorAll('.tab-link');
    }

    function panels(root) {
      return root.querySelectorAll('.tab-content');
    }

    function indexOfNode(list, node) {
      for (var i = 0; i < list.length; i++) {
        if (list[i] === node) return i;
      }
      return -1;
    }

    function syncCta(root, link) {
      if (!root || !link) return;
      var cta = root.querySelector('[data-tabs-cta]');
      var href = link.getAttribute('data-cta-href');
      if (cta && href) cta.setAttribute('href', href);
    }

    /* Exactly one open tab: the theme can leave "current" on more than one. */
    function enforceSingle(root, index) {
      var l = links(root);
      var p = panels(root);
      var i;
      for (i = 0; i < l.length; i++) l[i].classList.toggle('current', i === index);
      for (i = 0; i < p.length; i++) p[i].classList.toggle('current', i === index);
    }

    function openIndexes(root) {
      var p = panels(root);
      var open = [];
      for (var i = 0; i < p.length; i++) {
        if (p[i].classList.contains('current')) open.push(i);
      }
      return open;
    }

    function openDefault(root) {
      var l = links(root);
      var link = root.querySelector('.tab-link[data-tab-default="true"]');
      if (!link) return;

      var index = indexOfNode(l, link);
      if (index < 0) return;

      var open = openIndexes(root);
      if (open.length === 1 && open[0] === index) {
        syncCta(root, link);
        return;
      }

      // Drop "current" first so the theme's own handler treats this as a real
      // tab change (it switches the panels and resizes the carousel).
      link.classList.remove('current');
      link.click();

      enforceSingle(root, index);
      syncCta(root, link);
    }

    function boot() {
      var roots = document.querySelectorAll(ROOT);
      for (var i = 0; i < roots.length; i++) {
        (function (root) {
          // The theme initialises its tabs on its own schedule and re-asserts
          // the first tab, so run after it has had a chance to do that.
          setTimeout(function () {
            openDefault(root);
          }, 0);
          setTimeout(function () {
            openDefault(root);
          }, 400);
        })(roots[i]);
      }
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var link = target.closest('.tab-link');
      if (!link) return;
      var root = link.closest(ROOT);
      if (!root) return;

      var index = indexOfNode(links(root), link);
      if (index < 0) return;

      // Let the theme switch first, then make sure only this tab stayed open.
      setTimeout(function () {
        enforceSingle(root, index);
        syncCta(root, link);
      }, 0);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-block-slider"] && !Shopify.designMode) return;
  try {
    
    (function() {
        var section = document.querySelector('[data-recommendations]');
        if (!section) return;

        var productId = section.dataset.productId;
        var limit     = section.dataset.limit || 4;
        var sectionId = section.dataset.sectionId;

        var url =
        '/recommendations/products?section_id=' + sectionId +
        '&product_id=' + productId +
        '&limit=' + limit;

        fetch(url)
        .then(function(res) { return res.text(); })
        .then(function(html) {
            var parser = new DOMParser();
            var doc    = parser.parseFromString(html, 'text/html');
            var inner  = doc.querySelector('.product-recommendations');
            if (inner) section.innerHTML = inner.innerHTML;
        });
    })();

  } catch(e) { console.error(e); }
})();
})();
